(function () {
  /* ------------------------------
     Helpers
  --------------------------------*/

  function moneyFromCents(cents) {
    const n = (Number(cents) || 0) / 100;
    return n.toLocaleString(undefined, { style: "currency", currency: "USD" });
  }

  function pluralizeLockTitle(title, qty) {
    if (qty <= 1) return title;
    return title.replace(/\bLock\b/i, "Locks");
  }

  function getBikeCountFromPage() {
    const root = document.querySelector("main") || document.body;
    if (!root) return 1;

    const text = root.innerText || "";

    let m =
      text.match(/Rack Options:\s*(\d+)\s*-\s*Bike/i) ||
      text.match(/Rack Options:\s*(\d+)\s*Bike/i);

    if (m) return Math.max(1, parseInt(m[1], 10));

    m = text.match(/\b(\d+)\s*-\s*Bike\b/i) || text.match(/\b(\d+)\s*Bike\b/i);
    if (m) return Math.max(1, parseInt(m[1], 10));

    return 1;
  }

  function updateAccessoryLines() {
    const bikeCount = getBikeCountFromPage();
    const rows = document.querySelectorAll(".r88-accessory-addons .r88-addon");

    rows.forEach((row) => {
      const cb = row.querySelector(".r88-addon-checkbox");
      if (!cb) return;

      const rule = (cb.dataset.multRule || "").trim();
      const unitPrice = Number(cb.dataset.unitPrice || 0) || Number(cb.getAttribute("data-unit-price") || 0);

      const priceEl = row.querySelector(".r88-addon-price");
      const multEl = row.querySelector(".r88-addon-mult");
      const titleNode = row.querySelector(".r88-addon-title");

      if (!priceEl) return;

      const baseTitleRaw =
        (cb.dataset.title || "").toString().trim() ||
        (titleNode ? titleNode.textContent.replace(/^Add\s+/i, "").trim() : "");

      if (rule === "bikes") {
        const qty = bikeCount;
        const title = pluralizeLockTitle(baseTitleRaw, qty);

        if (titleNode) titleNode.textContent = "Add " + title;
        if (multEl) multEl.textContent = qty > 1 ? ` x${qty}` : "";
        priceEl.textContent = `(${moneyFromCents(unitPrice * qty)})`;
      } else {
        if (titleNode) titleNode.textContent = "Add " + baseTitleRaw;
        if (multEl) multEl.textContent = "";
        priceEl.textContent = `(${moneyFromCents(unitPrice)})`;
      }
    });
  }

  function getCheckedAddons() {
    return Array.from(document.querySelectorAll(".r88-accessory-addons .r88-addon-checkbox:checked"));
  }

  async function addMainAndAccessories(form) {
    const accChecks = getCheckedAddons();
    if (accChecks.length === 0) return false;

    const mainVariantId = form.querySelector('input[name="id"]')?.value;

    const qtyEl = form.querySelector('input[name="quantity"]');
    const mainQty = qtyEl ? Math.max(1, parseInt(qtyEl.value || "1", 10)) : 1;

    const bikeCount = getBikeCountFromPage();

    const items = [];
    if (mainVariantId) items.push({ id: Number(mainVariantId), quantity: mainQty });

    accChecks.forEach((cb) => {
      const vid = Number(cb.dataset.variantId);
      if (!vid) return;

      let q = 1;
      if ((cb.dataset.multRule || "").trim() === "bikes") q = bikeCount;

      items.push({ id: vid, quantity: q });
    });

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items }),
    });

    if (!res.ok) throw new Error(await res.text());
    return true;
  }

  /* ------------------------------
     Keep UI updated
  --------------------------------*/

  document.addEventListener("DOMContentLoaded", updateAccessoryLines);
  updateAccessoryLines();

  document.addEventListener("change", (e) => {
    if (e.target.closest && e.target.closest('form[action*="/cart/add"]')) {
      setTimeout(updateAccessoryLines, 0);
    }
  });

  document.addEventListener("click", (e) => {
    if (e.target.closest && e.target.closest('form[action*="/cart/add"]')) {
      setTimeout(updateAccessoryLines, 0);
    }
  });

  const observerTarget = document.querySelector("main") || document.body;
  if (observerTarget && window.MutationObserver) {
    const mo = new MutationObserver(() => {
      if (mo._t) cancelAnimationFrame(mo._t);
      mo._t = requestAnimationFrame(updateAccessoryLines);
    });
    mo.observe(observerTarget, { childList: true, subtree: true, characterData: true });
  }

  /* ------------------------------
     Intercept Add To Cart ONLY
     (and never Checkout)
  --------------------------------*/

  let inFlight = false;

  function isCheckoutButton(btn) {
    if (!btn) return false;
    if (btn.name === "checkout") return true;
    const txt = (btn.textContent || "").trim().toLowerCase();
    if (txt === "checkout") return true;
    // Any button inside a non-/cart/add form should be ignored anyway, but this is extra safety.
    return false;
  }

  // Capture submit (some themes submit normally)
  document.addEventListener(
    "submit",
    async function (e) {
      const form = e.target && e.target.matches && e.target.matches('form[action*="/cart/add"]') ? e.target : null;
      if (!form) return;

      if (inFlight) return;

      const accChecks = getCheckedAddons();
      if (accChecks.length === 0) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      inFlight = true;
      try {
        await addMainAndAccessories(form);
        document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { open: true } }));
      } catch (err) {
        console.error("Accessory add failed:", err);
        // Fall back to main product only if something goes wrong
        try {
          form.submit();
        } catch (_) {}
      } finally {
        inFlight = false;
      }
    },
    true
  );

  // Capture click (some themes never actually submit)
  document.addEventListener(
    "click",
    async function (e) {
      const btn = e.target.closest && e.target.closest('button[type="submit"], input[type="submit"]');
      if (!btn) return;

      if (isCheckoutButton(btn)) return;

      // Only run if the clicked submit is inside the product add-to-cart form.
      const form = btn.closest && btn.closest('form[action*="/cart/add"]');
      if (!form) return;

      if (inFlight) return;

      const accChecks = getCheckedAddons();
      if (accChecks.length === 0) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      inFlight = true;
      try {
        await addMainAndAccessories(form);
        document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { open: true } }));
      } catch (err) {
        console.error("Accessory add failed:", err);
      } finally {
        inFlight = false;
      }
    },
    true
  );

  /* ------------------------------
     Close any open Quick View drawers when cart opens
  --------------------------------*/

  function closeOpenQuickViews() {
    document.querySelectorAll("quick-view-modal[open]").forEach((qv) => {
      try {
        qv.hide();
      } catch (e) {
        qv.removeAttribute("open");
      }
    });
  }

  document.addEventListener("cart:refresh", (e) => {
    if (e && e.detail && e.detail.open === true) {
      closeOpenQuickViews();
    }
  });
})();
